import { Pressable } from '@atlaskit/primitives/pressable';
import type { XCSS } from '@atlaskit/primitives/xcss/xcss';
import { type ReactNode } from 'react';
import { type JSX } from 'react/jsx-runtime';

export type BaseButtonProps = {
	ctaText: ReactNode;
	onCTAClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export type PressableProps = BaseButtonProps & {
	pressableStyle: XCSS;
};

export const NextBestActionPressable = ({
	ctaText,
	onCTAClick,
	pressableStyle,
}: PressableProps): JSX.Element => {
	return (
		<Pressable onClick={onCTAClick} xcss={pressableStyle}>
			{ctaText}
		</Pressable>
	);
};
